/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/enum/DateTimeFormat.ts
 * @create:      2025-06-29 08:51:24.348
 * @modify:      2025-07-11 21:19:12.912
 * @version:     6.0.0
 * @times:       6
 * @lines:       130
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * @version 1.0.0
 * @since 1.0.5
 */
export enum DateTimeFormat {
    /**
     * @version 1.0.0
     * @since 1.0.5
     */
    FullDataTime = "YYYY-MM-DD HH:mm:ss.SSS",
    /**
     * @version 1.0.0
     * @since 1.0.5
     */
    ForFileName = "YYYY_MM_DD HH_mm_ss_SSS",
    /**
     * @since 1.0.5
     * @version 1.0.0
     */
    YearMonth = "YYYYMM",

    /**
     * 1993-01-21
     * @since 1.1.4
     * @version 2018-08-15
     */
    YearMonthDay = "YYYY-MM-DD",

    /**
     * 1993-01-21 02:32
     * @version 2018-08-18 08:57:41.740
     * @since 1.1.5
     */
    YearMonthDayHourMinute = "YYYY-MM-DD HH:mm",
    // #region
    /**
     * 1993-01-21T16:34
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    DATETIME_LOCAL = "YYYY-MM-DDTHH:mm",
    /**
     * 1993-01-21T16:34:10
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    DATETIME_LOCAL_SECONDS = "YYYY-MM-DDTHH:mm:ss",
    /**
     * 1993-01-21T16:34:10.234
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    DATETIME_LOCAL_MS = "YYYY-MM-DDTHH:mm:ss.SSS",
    /**
     * 1993-01-21
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    DATE = YearMonthDay,
    /**
     * 16:34
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    TIME = "HH:mm",
    /**
     * 16:34:10
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    TIME_SECONDS = "HH:mm:ss",
    /**
     * 16:34:10.234
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    TIME_MS = "HH:mm:ss.SSS",
    /**
     * 1993-W03
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    WEEK = "YYYY-[W]WW",
    /**
     * 1993-01
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    MONTH = "YYYY-MM",
    // #endregion
    /**
     * 1993年01月21日
     * @version 2018-08-18 15:07:49.379
     * @since 1.1.5
     */
    CN_DATE = "YYYY年MM月DD日",
}
